// extracted by mini-css-extract-plugin
module.exports = {"heroIcon":"HeroIcons-module--heroIcon--269aY","bgBonds":"HeroIcons-module--bgBonds--hATrL"};